module.exports = __webpack_public_path__ + "img/404-Error-Page-not-Found-with-people-connecting-a-plug-amico.1aee5a63.png";